import { IGameState } from '../../../State/Game/IGameState';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import BaseMenu from './BaseMenu';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import UITextComponent from '../../../Component/UI/Text';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import Renderable from '../../../Component/Renderable';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { applyDefaultButtonAnimation } from '../UIHelper';
import ElementComponent from '../../../Component/UI/Element';
import Game from '../../../Game';

const TITLE: string = 'main_container/noLives_title';
const BTN_CLOSE: string = 'main_container/close_button';
const BTN_SPIN_WHEEL: string = 'main_container/spin_wheel_button';
const BTN_PURCHASE: string = 'main_container/purchase_button';
const BTN_PURCHASE_TEXT: string =
    'main_container/purchase_button/purchase_text';

export default class NoLivesMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('noLivesMenu', uiSystem);
    }

    public onShow(params?: any): void {
        // Hide "Spin Wheel" button if on desktop (ads not supported).
        if (Game.sdk.hasRewardedAdSupport()) {
            this.enableAds();
        } else {
            this.disableAds();
        }
    }

    public handleStateChanged(state: IGameState) {
        this.element.find(TITLE).getComponent(Renderable).visible =
            state.playerState.lives === 0;
    }

    protected onCreate(): void {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(UIActions.hidePopup(this.name));
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        // Button purchase.
        const btnPurchase = this.element.find(BTN_PURCHASE);
        btnPurchase.on(GameObjectEvent.SELECTED, () => {
            this.system.state.dispatch(PlayerActions.purchaseLife());
        });
        applyDefaultButtonAnimation(btnPurchase, AUDIO_UI_BUTTON_DEFAULT);

        const btnPurchaseText = this.element.find(BTN_PURCHASE_TEXT);
        btnPurchaseText.getComponent(UITextComponent).text = '200';

        // Button spin wheel.
        const btnSpinWheel = this.element.find(BTN_SPIN_WHEEL);
        btnSpinWheel.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.gameTracking(FBTrackingEvent.TapOnWheelLife);
            this.system.state.dispatch(UIActions.showPopup('wheelMenu'));
        });
        applyDefaultButtonAnimation(btnSpinWheel, AUDIO_UI_BUTTON_DEFAULT);
    }

    private enableAds(): void {
        const btnSpinWheel = this.element.find(BTN_SPIN_WHEEL);
        btnSpinWheel.getComponent(Renderable).visible = true;

        const btnPurchase = this.element.find(BTN_PURCHASE);
        const btnPurchaseElement = btnPurchase.getComponent(ElementComponent);
        btnPurchaseElement.anchorTopLeft.x = 0.7;
        btnPurchaseElement.anchorBottomRight.x = 0.7;
    }

    private disableAds(): void {
        const btnSpinWheel = this.element.find(BTN_SPIN_WHEEL);
        btnSpinWheel.getComponent(Renderable).visible = false;

        const btnPurchase = this.element.find(BTN_PURCHASE);
        const btnPurchaseElement = btnPurchase.getComponent(ElementComponent);
        btnPurchaseElement.anchorTopLeft.x = 0.5;
        btnPurchaseElement.anchorBottomRight.x = 0.5;
    }
}
